var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPurchaseDate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2955 21.2349C18.9005 21.2349 21.0122 19.1231 21.0122 16.5182C21.0122 13.9132 18.9005 11.8015 16.2955 11.8015C13.6906 11.8015 11.5789 13.9132 11.5789 16.5182C11.5789 19.1231 13.6906 21.2349 16.2955 21.2349Z",
    stroke: "#8A92A6",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69181 3H5.30013V4.39168H6.69181V3Z",
    fill: "#8A92A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8962 3H16.5045V4.39168H17.8962V3Z",
    fill: "#8A92A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65819 12.1449C9.05239 12.1449 9.37195 11.8254 9.37195 11.4312C9.37195 11.037 9.05239 10.7174 8.65819 10.7174C8.26399 10.7174 7.94443 11.037 7.94443 11.4312C7.94443 11.8254 8.26399 12.1449 8.65819 12.1449Z",
    fill: "#8A92A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.305 20.5032H4.40186C4.21773 20.5032 4.0354 20.4669 3.86529 20.3964C3.69518 20.3259 3.54062 20.2226 3.41044 20.0924C3.28026 19.9622 3.17701 19.8076 3.10658 19.6375C3.03616 19.4673 2.99994 19.285 3 19.1009V5.79426C3 5.42246 3.14769 5.06589 3.41059 4.80299C3.67349 4.54009 4.03006 4.3924 4.40186 4.3924H18.8652C19.0493 4.39234 19.2316 4.42855 19.4018 4.49898C19.5719 4.5694 19.7265 4.67265 19.8567 4.80283C19.9869 4.93301 20.0902 5.08757 20.1607 5.25768C20.2312 5.42779 20.2675 5.61012 20.2675 5.79426V11.2327",
    stroke: "#8A92A6",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00046 9.08986H20.2675",
    stroke: "#8A92A6",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75189 12.1449C6.14609 12.1449 6.46566 11.8254 6.46566 11.4312C6.46566 11.037 6.14609 10.7174 5.75189 10.7174C5.35769 10.7174 5.03813 11.037 5.03813 11.4312C5.03813 11.8254 5.35769 12.1449 5.75189 12.1449Z",
    fill: "#8A92A6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65819 15.0658C9.05239 15.0658 9.37195 14.7462 9.37195 14.352C9.37195 13.9578 9.05239 13.6383 8.65819 13.6383C8.26399 13.6383 7.94443 13.9578 7.94443 14.352C7.94443 14.7462 8.26399 15.0658 8.65819 15.0658Z",
    fill: "#8A92A6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69217 15.0658C6.08637 15.0658 6.40593 14.7462 6.40593 14.352C6.40593 13.9578 6.08637 13.6383 5.69217 13.6383C5.29797 13.6383 4.97841 13.9578 4.97841 14.352C4.97841 14.7462 5.29797 15.0658 5.69217 15.0658Z",
    fill: "#8A92A6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6492 12.1449C12.0434 12.1449 12.3629 11.8254 12.3629 11.4312C12.3629 11.037 12.0434 10.7174 11.6492 10.7174C11.255 10.7174 10.9354 11.037 10.9354 11.4312C10.9354 11.8254 11.255 12.1449 11.6492 12.1449Z",
    fill: "#8A92A6"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69217 18.0746C6.08637 18.0746 6.40593 17.7551 6.40593 17.3609C6.40593 16.9667 6.08637 16.6471 5.69217 16.6471C5.29797 16.6471 4.97841 16.9667 4.97841 17.3609C4.97841 17.7551 5.29797 18.0746 5.69217 18.0746Z",
    fill: "#8A92A6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65819 18.0746C9.05239 18.0746 9.37195 17.7551 9.37195 17.3609C9.37195 16.9667 9.05239 16.6471 8.65819 16.6471C8.26399 16.6471 7.94443 16.9667 7.94443 17.3609C7.94443 17.7551 8.26399 18.0746 8.65819 18.0746Z",
    fill: "#8A92A6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69181 4.37202H5.30013V5.76371H6.69181V4.37202Z",
    fill: "#8A92A6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8962 4.37202H16.5045V5.76371H17.8962V4.37202Z",
    fill: "#8A92A6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3001 16.0965L15.2644 18.29L19.2903 14.7465",
    stroke: "#8A92A6",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPurchaseDate);
export default __webpack_public_path__ + "static/media/ic_purchase_date.4631eb959ae96e1a641da144c2383c74.svg";
export { ForwardRef as ReactComponent };